var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCameraRecord = function SvgCameraRecord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.524 14.735a2.382 2.382 0 0 0 1.519-2.998 2.362 2.362 0 0 0-2.981-1.527 2.382 2.382 0 0 0-1.518 2.998 2.362 2.362 0 0 0 2.98 1.527ZM12.688 6.975a1.62 1.62 0 0 0 1.032-2.038 1.606 1.606 0 0 0-2.026-1.039 1.62 1.62 0 0 0-1.033 2.039 1.606 1.606 0 0 0 2.027 1.038ZM90.231 15.142a3.631 3.631 0 0 0 .23-5.11 3.58 3.58 0 0 0-5.08-.23 3.631 3.631 0 0 0-.229 5.11 3.58 3.58 0 0 0 5.08.23ZM97.715 8.549c.617-.567.66-1.53.096-2.151a1.508 1.508 0 0 0-2.139-.097 1.529 1.529 0 0 0-.096 2.151c.564.62 1.522.664 2.139.097ZM11.683 93.08c.618-.567.66-1.53.097-2.151a1.508 1.508 0 0 0-2.14-.097 1.529 1.529 0 0 0-.095 2.151c.564.621 1.521.664 2.138.097Z",
    fill: "#0A0A0B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.855 98.109c25.97 0 47.023-21.175 47.023-47.297 0-26.12-21.053-47.296-47.023-47.296-25.97 0-47.023 21.175-47.023 47.296S23.885 98.11 49.855 98.11Z",
    fill: "#181818"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.738 8.47c-4.813-2.78-10.946-1.168-13.697 3.598L15.109 46.591c-2.752 4.767-1.081 10.883 3.732 13.662l43.574 25.158c4.813 2.779 10.946 1.168 13.698-3.599l19.932-34.523c2.752-4.767 1.081-10.883-3.732-13.662L48.738 8.469Z",
    fill: "#222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.353 12.785c-6.145-1.253-12.133 2.664-13.374 8.75l-8.99 44.074c-1.241 6.086 2.734 12.035 8.879 13.288l55.63 11.348c6.145 1.253 12.133-2.664 13.374-8.75l8.99-44.075c1.242-6.085-2.733-12.034-8.878-13.288L28.353 12.785Z",
    fill: "#272727"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.878 23.563c-5.365 0-9.714 4.477-9.714 10v40c0 5.522 4.35 10 9.714 10H74.45c5.365 0 9.714-4.478 9.714-10v-40c0-5.523-4.35-10-9.714-10H25.878Z",
    fill: "#313131"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3 40.672c-2.375 0-4.3 1.865-4.3 4.167v16.666c0 2.301 1.925 4.167 4.3 4.167h21.5c2.375 0 4.3-1.866 4.3-4.167V44.84c0-2.302-1.925-4.167-4.3-4.167H33.3Z",
    fill: "url(#camera-record_svg__a)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.017 48.797c-.486.396-.767.98-.767 1.596v5.558c0 .615.28 1.2.767 1.595l7.157 5.825c1.119.911 2.826.14 2.826-1.276V44.25c0-1.417-1.707-2.188-2.826-1.277l-7.157 5.825Z",
    fill: "url(#camera-record_svg__b)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M97.664 82.84c0 .833-.083 1.583-.167 2.416-.833 5.5-4.582 10-9.665 11.916-1.75.667-3.583 1-5.5 1-5.333 0-10.082-2.75-12.832-6.916A15.364 15.364 0 0 1 67 82.84c0-8.5 6.833-15.332 15.332-15.332 8.416 0 15.332 6.916 15.332 15.332Z",
    fill: "url(#camera-record_svg__c)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.332,
    cy: 82.843,
    rx: 4.992,
    ry: 4.991,
    fill: "url(#camera-record_svg__d)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "camera-record_svg__a",
    x1: 51,
    y1: 65.672,
    x2: 51,
    y2: 40.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBC2CA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBC2CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "camera-record_svg__b",
    x1: 51,
    y1: 65.672,
    x2: 51,
    y2: 40.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBC2CA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBC2CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "camera-record_svg__c",
    x1: 82.306,
    y1: 65.457,
    x2: 82.306,
    y2: 99.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA6964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC2E26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "camera-record_svg__d",
    x1: 84.855,
    y1: 86.037,
    x2: 78.351,
    y2: 78.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#FFCFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
};
export default SvgCameraRecord;